export default __webpack_public_path__ + "5979fc90b542ec91759303755d80146d.png";